import React, { useRef, useState } from 'react';
import './AssignDemoTrialLicense.css';
import PopupDialog from 'src/SharedComponents/PopupDialog/PopupDialog';
import { CloseIcon } from 'src/SharedComponents/Icons/Icons';
import SearchBar from 'src/SharedComponents/SearchBar/SearchBar';
import TableHead from "src/SharedComponents/Table/TableHead";
import { useSearch } from "src/Utils/Hooks/SearchData/useSearch";
import tableStyles from 'src/Utils/CssModules/table.module.css';
import Button from 'src/SharedComponents/Button/Button';
import useSortableData, { SortConfig } from 'src/Utils/Hooks/SortableData/useSortableData';
import { useAuraSupportInfo } from 'src/Utils/Hooks/UseAuraInfoContext';
import { useSupportPermissions } from 'src/Utils/Hooks/useGetAdminInfo/useSupportPermissions';
import { IPartner } from 'src/Utils/Hooks/useGetAdminInfo/useGetAuraSupportInfo';
import { formatDateString } from 'src/Utils/DateFormatting/DateFormatter';

interface AssignDemoTrialLicenseProps {
    licenseType: string;
    onClose: () => void;
    onSubmit: (clinicId: string, licenseType: string, clinicName: string) => void;
}


const AssignDemoTrialLicenseToPartner: React.FC<AssignDemoTrialLicenseProps> = ({licenseType, onClose, onSubmit}) => {
    const [searchText, setSearchText] = useState<string>('');
    const { adminDetails } = useAuraSupportInfo();
    const { isSupportAdmin } = useSupportPermissions();

    let conf: SortConfig<IPartner> = {
        key: 'name',
        direction: 'ascending'
    };

    const searchKeys = useRef<(keyof IPartner)[]>(['name'])
    const partnerSearch = useSearch(adminDetails?.partners, searchText, searchKeys.current);
    const { items, requestSort, sortConfig } = useSortableData(partnerSearch, conf);

    return (
        <div className="assignLicenseToPartner">
            <PopupDialog onClose={() => onClose()} marginTop="120px" popupWidth="45%">
                <div className="assign-license-header d-flex flex-column row">
                    <div className="d-flex justify-content-between align-items-center">
                        <span style={{ fontWeight: '600', fontSize: '24px' }}>Assign Demo/Trail License</span>
                        <i style={{ cursor: 'pointer' }} onClick={() => { onClose() }}>
                            <CloseIcon />
                        </i>
                    </div>
                    <div className="row ps-4 ds-text-base ds-text-primary ds-font-regular">
                        Select a Partner
                    </div>
                    <div className="row mt-4">
                        <SearchBar onChange={(text:string) => {setSearchText(text) }} />
                    </div>
                </div>
                <div className="table-responsive" style={{overflowX:"hidden", borderRadius:'20px', marginBottom:'2px'}}>
                <table data-testid="table" className={`table ${tableStyles.tableStriped}`}>
                        <thead className={`${tableStyles.tableHead}`}>
                            <tr key={'header'}>
                                <TableHead<IPartner>
                                    columnName="Partner" 
                                    paddingLeft="25px"
                                    requestSort={requestSort}
                                    sortConfig={sortConfig}
                                    columnkey="name"
                                />
                               
                                <TableHead<IPartner>
                                    columnName="Country"
                                    paddingLeft="25px"
                                    requestSort={requestSort}
                                    sortConfig={sortConfig}
                                    columnkey="country"
                                />

                                <TableHead<IPartner>
                                    columnName="SetUpDate" 
                                    paddingLeft="25px"
                                    requestSort={requestSort}
                                    sortConfig={sortConfig}
                                    columnkey="setUpDate"
                                />
                                <th className={tableStyles.heading}>{ }</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((partner, i) => (
                                <tr key={i}>
                                    <td className={tableStyles.data} style={{width:"40%", paddingLeft:'25px' }}>
                                        {partner.name}
                                    </td>
                                    <td className={tableStyles.data} style={{width:"30%", paddingLeft:'25px' }}>
                                        {partner.country}
                                    </td>
                                    <td className={tableStyles.data} style={{width:"30%", paddingLeft:'25px'  }}>
                                        {formatDateString(partner.setUpDate)}
                                    </td>
                                    <td className={tableStyles.data} style={{ fontWeight: 600}}>
                                        <Button
                                            backgroundColor="var(--primary-color)"
                                            color="white"
                                            text="Assign"
                                            borderColor="none"
                                            fontSize="12px"
                                            width='127px'
                                            disable={!isSupportAdmin}
                                            onClick={()=>onSubmit(partner.distributorId, licenseType, partner.name)}
                                        />
                                    </td>
                                </tr>
                            ))}
                        
                        </tbody>
                    </table>
                </div>
            </PopupDialog>
        </div>
    );
};

export default AssignDemoTrialLicenseToPartner;